import { requireField } from './validators';

export default class Certificate {
  constructor(data = {}) {
    requireField(data.name, 'certificate.name');
    requireField(data.issueDate, 'certificate.issueDate');

    this.id = data.id || `cert-${Math.random().toString(36).slice(2, 9)}`;
    this.name = data.name;
    this.issueDate = data.issueDate;
    this.expiryDate = data.expiryDate || null;
    this.fileName = data.fileName || '';
    this.archived = Boolean(data.archived);
    this.archivedAt = data.archivedAt || null;
    this.archivedBy = data.archivedBy || null;
    this.metadata = data.metadata || {};
  }

  toJSON() {
    return { ...this };
  }
}
